
import { mapGetters } from "vuex";

const pathAlias = "/img/slider-index";

export default {
  props: {
    slide: Object
  },
  computed: {
    ...mapGetters({
      settings: "settings/settings/settings"
    })
  },
  methods: {
    getSrc(format) {
      return `${pathAlias}/sslide-${this.slide.id}.${format}`;
    },
    getMobileSrc(format) {
      return `${pathAlias}/sslide-${this.slide.id}-mob.${format}`;
    }
  }
};
